export default __webpack_public_path__ + "static/brand-logo-piraeus-bank-7757726cc26761316f98740f614c99dc.svg";